<app-loading *ngIf="contentReady"></app-loading>

<div class="container-fluid p-0">
  <div>
    <div class="col-12 col-sm-12 main-content">
      <div class="container-fluid mb-4">
        <div class="categoryContainer">
          <div class="col-12">
            <button routerLink="/createdoctor" style="margin-left: 0;" class="first-btn btn btn-primary">
              انشاء طبيب
            </button>

            <button routerLink="/alldentist" style="margin-left: 0;" class="first-btn btn btn-primary">
              اسنان
            </button>

            <button (click)="getAllClients(pageSize, 1, true)" style="margin-left: 0;" class="first-btn btn btn-primary">
              {{ 'refresh' | translate }}
            </button>

            <div class="input-group mb-3">
              <input
                type="text"
                class="form-control"
                [(ngModel)]="searchKey"
                placeholder="ابحث بالاسم او الهاتف او التخصص او الجامعة"
                aria-label="Search"
                aria-describedby="basic-addon2"
                (keyup.enter)="search()"
              />

              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="search()" type="button">
                  {{ 'Search' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div>
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

            <!-- صورة الدكتور -->
            <ng-container matColumnDef="doctor_image">
              <th mat-header-cell *matHeaderCellDef>الصورة</th>
              <td mat-cell *matCellDef="let el">
                <ng-container *ngIf="getDoctorImage(el) as imageUrl; else noImage">
                  <a [href]="imageUrl" target="_blank" rel="noopener">
                    <img class="doctor-thumb" [src]="imageUrl" alt="Doctor image" />
                  </a>
                </ng-container>

                <ng-template #noImage>
                  <span class="empty-chip">لا توجد صورة</span>
                </ng-template>
              </td>
            </ng-container>

            <!-- الاسم -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>الاسم</th>
              <td mat-cell *matCellDef="let el">
                <strong class="doctor-name">{{ el.name || '-' }}</strong>

                <br />

                <span class="notes-chip" *ngIf="el.notes">
                  {{ el.notes }}
                </span>

                <br *ngIf="el.notes" />

                <span class="email-text">
                  {{ el.email || '-' }}
                </span>
              </td>
            </ng-container>

            <!-- الجوال -->
            <ng-container matColumnDef="mobile">
              <th mat-header-cell *matHeaderCellDef>رقم التليفون</th>
              <td mat-cell *matCellDef="let el">
                {{ el.mobile || '-' }}
              </td>
            </ng-container>

            <!-- التخصص -->
            <ng-container matColumnDef="specialty">
              <th mat-header-cell *matHeaderCellDef>التخصص</th>
              <td mat-cell *matCellDef="let el">
                <strong>{{ el.specialty || '-' }}</strong>
                <br />
                <span class="sub-info">الجامعة: {{ el.university || '-' }}</span>
                <br />
                <span class="sub-info">سنة التخرج: {{ el.graduation_year || '-' }}</span>
              </td>
            </ng-container>

            <!-- ماجستير -->
            <ng-container matColumnDef="has_master">
              <th mat-header-cell *matHeaderCellDef>ماجستير</th>
              <td mat-cell *matCellDef="let el">
                <span class="status-chip yes" *ngIf="isTruthy(el.has_master); else noMaster">✔</span>

                <ng-template #noMaster>
                  <span class="status-chip no">✖</span>
                </ng-template>

                <br />

                <span class="sub-info">المصدر: {{ el.master_source || '-' }}</span>
                <br />
                <span class="sub-info">السنة: {{ el.master_year || '-' }}</span>
              </td>
            </ng-container>

            <!-- دكتوراه -->
            <ng-container matColumnDef="has_phd">
              <th mat-header-cell *matHeaderCellDef>دكتوراه</th>
              <td mat-cell *matCellDef="let el">
                <span class="status-chip yes" *ngIf="isTruthy(el.has_phd); else noPhd">✔</span>

                <ng-template #noPhd>
                  <span class="status-chip no">✖</span>
                </ng-template>

                <br />

                <span class="sub-info">المصدر: {{ el.phd_source || '-' }}</span>
                <br />
                <span class="sub-info">السنة: {{ el.phd_year || '-' }}</span>
              </td>
            </ng-container>

            <!-- اوراق -->
            <ng-container matColumnDef="files">
              <th mat-header-cell *matHeaderCellDef>اوراق</th>
              <td mat-cell *matCellDef="let el">
                <div class="files-cell">
                  <div class="certificates-list" *ngIf="getCertificates(el).length; else noCertificates">
                    <a
                      class="file-chip"
                      *ngFor="let cert of getCertificates(el); let i = index"
                      [href]="getCertificateUrl(cert)"
                      target="_blank"
                      rel="noopener"
                    >
                      شهادة {{ i + 1 }}
                    </a>
                  </div>

                  <ng-template #noCertificates>
                    <span class="empty-chip">لا توجد شهادات</span>
                  </ng-template>
                </div>
              </td>
            </ng-container>

            <!-- الزمالة -->
            <ng-container matColumnDef="fellowship">
              <th mat-header-cell *matHeaderCellDef>الزمالة</th>
              <td mat-cell *matCellDef="let el">
                {{ el.fellowship || '-' }}
              </td>
            </ng-container>

            <!-- حالة التصنيف -->
            <ng-container matColumnDef="classification_status">
              <th mat-header-cell *matHeaderCellDef>حالة التصنيف</th>
              <td mat-cell *matCellDef="let el">
                {{ el.classification_status || '-' }}
              </td>
            </ng-container>

            <!-- خبرة السعودية -->
            <ng-container matColumnDef="ksa_experience">
              <th mat-header-cell *matHeaderCellDef>خبرة بالسعودية</th>
              <td mat-cell *matCellDef="let el">
                <span class="status-chip yes" *ngIf="isTruthy(el.ksa_experience); else noKsa">✔</span>
                <ng-template #noKsa>
                  <span class="status-chip no">✖</span>
                </ng-template>
              </td>
            </ng-container>

            <!-- مكان الإقامة -->
            <ng-container matColumnDef="residence_place">
              <th mat-header-cell *matHeaderCellDef>محل الاقامة</th>
              <td mat-cell *matCellDef="let el">
                {{ el.residence_place || '-' }}
              </td>
            </ng-container>

            <!-- مكان الميلاد -->
            <ng-container matColumnDef="birth_place">
              <th mat-header-cell *matHeaderCellDef>محل الميلاد</th>
              <td mat-cell *matCellDef="let el">
                {{ el.birth_place || '-' }}
              </td>
            </ng-container>

            <!-- تاريخ الميلاد -->
            <ng-container matColumnDef="birth_date">
              <th mat-header-cell *matHeaderCellDef>تاريخ الميلاد</th>
              <td mat-cell *matCellDef="let el">
                {{ el.birth_date ? formatFullDate(el.birth_date) : '-' }}
              </td>
            </ng-container>

            <!-- داتافلو -->
            <ng-container matColumnDef="has_dataflow">
              <th mat-header-cell *matHeaderCellDef>داتافلو</th>
              <td mat-cell *matCellDef="let el">
                <span class="status-chip yes" *ngIf="isTruthy(el.has_dataflow); else noDataflow">✔</span>
                <ng-template #noDataflow>
                  <span class="status-chip no">✖</span>
                </ng-template>
              </td>
            </ng-container>

            <!-- تأشيرة -->
            <ng-container matColumnDef="visa">
              <th mat-header-cell *matHeaderCellDef>تأشيرة</th>
              <td mat-cell *matCellDef="let el">
                <span class="status-chip yes" *ngIf="isTruthy(el.visa); else noVisa">✔</span>
                <ng-template #noVisa>
                  <span class="status-chip no">✖</span>
                </ng-template>
              </td>
            </ng-container>

            <!-- نقل الكفالة -->
            <ng-container matColumnDef="transfer_of_sponsorship">
              <th mat-header-cell *matHeaderCellDef>نقل الكفالة</th>
              <td mat-cell *matCellDef="let el">
                <span class="status-chip yes" *ngIf="isTruthy(el.transfer_of_sponsorship); else noTransfer">✔</span>
                <ng-template #noTransfer>
                  <span class="status-chip no">✖</span>
                </ng-template>
              </td>
            </ng-container>

            <!-- أضيف بواسطة -->
            <ng-container matColumnDef="add_by">
              <th mat-header-cell *matHeaderCellDef>أضيف بواسطة</th>
              <td mat-cell *matCellDef="let el">
                {{ el.add_by || '-' }}
                <br />
                <span class="sub-info">{{ el.created_at ? formatDate(el.created_at) : '-' }}</span>
              </td>
            </ng-container>

            <!-- تم التعديل -->
            <ng-container matColumnDef="editor">
              <th mat-header-cell *matHeaderCellDef>تم التعديل</th>
              <td mat-cell *matCellDef="let el">
                <ng-container *ngIf="el.editors?.length; else noEditor">
                  <span *ngFor="let editor of el.editors">
                    {{ editor }}
                    <br />
                    <span class="sub-info">{{ el.updated_at ? formatDate(el.updated_at) : '-' }}</span>
                    <br />
                  </span>
                </ng-container>

                <ng-template #noEditor>
                  <span class="empty-chip">-</span>
                </ng-template>
              </td>
            </ng-container>

            <!-- اتصال -->
            <ng-container matColumnDef="call">
              <th mat-header-cell *matHeaderCellDef class="text-center">اتصال</th>
              <td mat-cell *matCellDef="let el" class="text-center">
                <a class="chat" (click)="call(el.mobile)" *ngIf="el.mobile">
                  <img src="/assets/call.png" alt="Call" />
                </a>
              </td>
            </ng-container>

            <!-- محادثة -->
            <ng-container matColumnDef="chat">
              <th mat-header-cell *matHeaderCellDef class="text-center">شات</th>
              <td mat-cell *matCellDef="let el" class="text-center">
                <a class="chat" (click)="chat(el.mobile)" *ngIf="el.mobile">
                  <img src="/assets/chat.png" alt="Chat" />
                </a>
              </td>
            </ng-container>

            <!-- خيارات -->
            <ng-container matColumnDef="options">
              <th mat-header-cell *matHeaderCellDef>إجراءات</th>
              <td mat-cell *matCellDef="let element">
                <div class="dropdown">
                  <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </button>

                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item" (click)="edit(element)">تعديل</a>
                    </li>

                    @if(isAdmin){
                      <li>
                        <a class="dropdown-item" (click)="delete(element.id)">حذف</a>
                      </li>
                    }
                  </ul>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>

          <mat-paginator
            [length]="totalItems"
            [pageSize]="pageSize"
            [pageSizeOptions]="[10, 20, 50, 100]"
            (page)="onPaginateChange($event)"
          >
          </mat-paginator>
        </div>

        <div class="row">
          @if (noData) {
            <app-nodata></app-nodata>
          }
        </div>
      </div>
    </div>
  </div>
</div>